import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { ProductGrid } from '../product/ProductGrid';
import styles from './InfiniteScroll.module.scss';
import AppConfig from '../../config/config';
export function InfiniteScroll({ products, loading, layout = 'grid', mode = 'auto', pageSize, onFilterToggle, filters, onRemoveFilter, totalProducts, currentPage = 1, onPageChange, onResetFilters, onLoadMore, hasMore: hasMoreProp, }) {
    const loaderRef = useRef(null);
    const lastProductCountRef = useRef(0);
    const buttonRef = useRef(null);
    const scrollPositionRef = useRef(0);
    const wasFilterChangeRef = useRef(false);
    const [isMobile, setIsMobile] = useState(false);
    // Detect mobile device for responsive page size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);
    // Get responsive page size
    const getResponsivePageSize = () => {
        return pageSize || (isMobile ? AppConfig.page.mobileSize : AppConfig.page.defaultSize);
    };
    const responsivePageSize = getResponsivePageSize();
    const hasMore = hasMoreProp !== null && hasMoreProp !== void 0 ? hasMoreProp : (totalProducts
        ? currentPage * responsivePageSize < totalProducts
        : false);
    // Only show skeletons on initial load (when products array is empty)
    const showSkeletons = products.length === 0;
    return (h("div", null,
        h(ProductGrid, { products: products, loading: loading, layout: layout, onFilterToggle: onFilterToggle, filters: filters, onRemoveFilter: onRemoveFilter, onResetFilters: onResetFilters, showSkeletons: showSkeletons, pageSize: responsivePageSize }),
        hasMore && mode === 'auto' && (h("div", { ref: loaderRef, style: { height: 40 } }))));
}
// Placeholder component to prevent CLS during initial load
export function LoadMoreButtonPlaceholder() {
    return (h("div", { className: styles.loadMoreContainer },
        h("div", { className: styles.productCountPlaceholder }),
        h("div", { className: styles.progressBarPlaceholder }),
        h("div", { className: styles.loadMoreButtonPlaceholder })));
}
export function LoadMoreButton({ products, totalProducts, onLoadMore, disabled = false, }) {
    // Don't render anything if there are no products and no totalProducts
    if (products.length === 0 && !totalProducts) {
        return null;
    }
    return (h("div", { className: styles.loadMoreContainer },
        totalProducts && (h(Fragment, null,
            h("div", { className: styles.productCount },
                "You've viewed ",
                products.length,
                " out of ",
                totalProducts,
                " products"),
            h("div", { className: styles.progressBarContainer },
                h("div", { className: styles.progressBar, style: {
                        width: `${(products.length / totalProducts) * 100}%`,
                    } })))),
        totalProducts && products.length < totalProducts && (h("button", { onClick: onLoadMore, className: styles.loadMoreButton, disabled: disabled || products.length === totalProducts }, "Load More"))));
}
